import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HelpModel } from '../../../shared/help/help.model';
import { ApiResponse } from '../../../models/base';

const ENDPOINT = '/admin/help';

@Injectable({
  providedIn: 'root',
})
export class HelpService {
  constructor(private http: HttpClient) {}

  GetHelp(helpUid: string): Promise<HelpModel> {
    return firstValueFrom(
      this.http.get<ApiResponse<HelpModel>>(environment.apiUrl + ENDPOINT + `/${helpUid}`)
    ).then((response) => response.data);
  }

  GetHelpList(): Promise<HelpModel[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<HelpModel[]>>(environment.apiUrl + ENDPOINT)
    ).then((response) => response.data);
  }

  NewHelp(data: HelpModel): Promise<HelpModel> {
    return firstValueFrom(
      this.http.post<ApiResponse<HelpModel>>(environment.apiUrl + ENDPOINT, data)
    ).then((response) => response.data);
  }

  deleteHelp(helpUid: string): Promise<string> {
    return firstValueFrom(
      this.http.delete<ApiMessageResponse>(environment.apiUrl + ENDPOINT + `/${helpUid}`)
    ).then((response) => response.message);
  }

  editHelp(helpUid: string, data: HelpModel): Promise<HelpModel> {
    return firstValueFrom(
      this.http.put<ApiResponse<HelpModel>>(environment.apiUrl + ENDPOINT + `/${helpUid}`, data)
    ).then((response) => response.data);
  }
}

export interface ApiMessageResponse {
  message: string;
}